var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    color: "#999",
    fill: "currentColor",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.415 7L12 15.01 19.585 7 21 8.495 12 18 3 8.495 4.415 7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.8690b7cdb8ed988b95a0b28e8e557693.svg";
export { ForwardRef as ReactComponent };